"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledItem = exports.StyledFetchingLoading = exports.StyledSearchingLoading = exports.StyledProfileName = exports.StyledActionContainer = exports.StyledProfileItem = exports.StyledSearchEmptyResult = exports.StyledProfileItems = exports.StyledSearchResult = exports.StyledSearchWrapper = exports.StyledSharedUsers = exports.StyledContent = exports.StyledExistingItemsList = exports.StyledExistingItems = exports.StyledSearchItems = exports.StyledFooter = exports.StyledHeader = exports.StyledWrapper = void 0;
const styled_components_1 = require("styled-components");
const ui_common_components_1 = require("@desygner/ui-common-components");
exports.StyledWrapper = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  width: 100%;
`;
exports.StyledHeader = styled_components_1.default.div `
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: ${({ theme }) => ui_common_components_1.utils.rem(theme.Spacing.Size.Small)};
  color: ${({ theme }) => theme.Color.Neutrals.Dark};
`;
exports.StyledFooter = styled_components_1.default.div `
  display: flex;
  align-items: center;
  gap: ${({ theme }) => ui_common_components_1.utils.rem(theme.Spacing.Size.Medium)};
  justify-content: space-between;
  padding-top: ${({ theme }) => ui_common_components_1.utils.rem(theme.Spacing.Size.Medium)};
  border-top: 1px solid transparent;
`;
exports.StyledSearchItems = styled_components_1.default.div `
  border: 1px solid ${({ theme }) => theme.Color.Neutrals.Border};
  border-radius: ${({ theme }) => theme.Border.Radius.Small}px;
`;
exports.StyledExistingItems = styled_components_1.default.section `
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => ui_common_components_1.utils.rem(theme.Spacing.Size.Medium)};
`;
exports.StyledExistingItemsList = styled_components_1.default.section `
  display: flex;
  flex-direction: column;
  max-height: 210px;
  overflow-y: auto;
`;
exports.StyledContent = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  min-height: 12rem;
`;
exports.StyledSharedUsers = styled_components_1.default.div `
  margin-top: ${({ theme }) => ui_common_components_1.utils.rem(theme.Spacing.Size.Medium)};
  display: flex;
  flex-direction: column;
  min-height: 12rem;
`;
exports.StyledSearchWrapper = styled_components_1.default.section `
  margin: 0;
  position: relative;
`;
exports.StyledSearchResult = styled_components_1.default.section `
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: ${({ theme }) => `${ui_common_components_1.utils.rem(theme.Spacing.Size.XXSmall)} ${ui_common_components_1.utils.rem(theme.Spacing.Size.XSmall)}`};
  position: absolute;
  border-radius: ${({ theme }) => theme.Border.Radius.Small}px;
  border: 1px solid ${({ theme }) => theme.Color.Neutrals.Border};
  background: ${({ theme }) => theme.Color.Neutrals.Paper};
  width: 100%;
  z-index: 1;
  margin-top: ${({ theme }) => ui_common_components_1.utils.rem(theme.Spacing.Size.XXSmall)};
`;
exports.StyledProfileItems = (0, styled_components_1.default)(exports.StyledSearchResult) `
  min-height: ${ui_common_components_1.utils.rem(3)};
  max-height: ${ui_common_components_1.utils.rem(195)};
  overflow-y: auto;
`;
exports.StyledSearchEmptyResult = (0, styled_components_1.default)(exports.StyledSearchResult) `
  padding: ${({ theme }) => ui_common_components_1.utils.rem(theme.Spacing.Size.Small)};
`;
exports.StyledProfileItem = styled_components_1.default.div `
  display: flex;
  gap: ${({ theme }) => ui_common_components_1.utils.rem(theme.Spacing.Size.Small)};
  align-items: center;
`;
exports.StyledActionContainer = styled_components_1.default.div `
  flex: 0;
`;
exports.StyledProfileName = (0, styled_components_1.default)(ui_common_components_1.Text) `
  flex: 1 1 auto;
`;
exports.StyledSearchingLoading = (0, styled_components_1.default)(exports.StyledSearchResult) `
  align-items: center;
  padding: ${({ theme }) => ui_common_components_1.utils.rem(theme.Spacing.Size.Small)};
`;
exports.StyledFetchingLoading = styled_components_1.default.section `
  display: flex;
  width: 100%;
  justify-content: center;
`;
exports.StyledItem = styled_components_1.default.span `
  width: 100%;
  padding: 0
    ${({ theme }) => theme.Spacing.Size.XXSmall / 2 + theme.Spacing.Size.XSmall}rem;
  text-overflow: ellipsis;
  text-align: left;
`;
//# sourceMappingURL=Collaborate.style.js.map